import React from 'react'
import filterSearch from '../../assets/filter-empty.svg';

export const EmptyStateTwo = ({ message }) => {
    return (
        <div className="d-flex flex-column align-items-center">
            <img src={filterSearch} alt="" />
            <p className="mt-2">{message}</p>
        </div>
    )
}
